﻿import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Context, { context_type } from '@Util/Context';
import { useTranslation } from 'react-i18next';
import { SnackbarContent } from '@mui/material';
import Stack from '@mui/material/Stack';
import { H3, P } from '@Elements/Fonts';
import { dashboard_pages } from '@Util/GlobalValues';

import { Reminder } from '@Util/Types';

export default function Reminder_Notification(): JSX.Element {
    const [t] = useTranslation();
    const { overdue_reminders }: context_type = useContext(Context);
    const navigate = useNavigate();

    return (
        <Stack
            spacing={2}
            sx={{ position: 'absolute', bottom: 20, right: 20, zIndex: 1300 }}
        >
            {overdue_reminders?.map((reminder: Reminder) => (
                <SnackbarContent
                    key={reminder.id}
                    className="Overdue_Reminder"
                    onClick={() => navigate(dashboard_pages.reminders)}
                    message={
                        <div className="Overdue_Reminder_Content">
                            <H3>{t('Text.OverdueReminder')}</H3>
                            <P>{reminder.content}</P>
                        </div>
                    }
                    sx={{ maxWidth: 600, cursor: 'pointer' }}
                />
            ))}
        </Stack>
    );
}